import clsx from 'clsx';

import { numberToLocaleString } from '@atom/utilities/currencyUtility';
import { convertMillisToExactHours } from '@atom/utilities/timeUtilities';

import { ReportUser } from './reportUtilities';

import classes from './workOrderReport.module.css';

interface Props {
  user: ReportUser;
  isCompletedOrAbove: boolean;
}

const ReportUserRow = ({ user, isCompletedOrAbove }: Props) => {
  const getDurationDisplay = () => {
    if (user?.duration) {
      return convertMillisToExactHours(user?.duration);
    }

    if (!user?.duration && isCompletedOrAbove) {
      return '-';
    }

    return '';
  };

  const duration = getDurationDisplay();

  return (
    <div className={classes.usersTableRow}>
      <div className={classes.usersTableSubRow}>
        <div className={clsx(classes.usersRowCell, classes.name)}>
          {user?.isTeamLead && (
            <span className={classes.teamLead}>&#9733;</span>
          )}
          {user?.name}
        </div>
        <div className={classes.usersRowCell}>{duration}</div>
      </div>
      {isCompletedOrAbove && (
        <div className={clsx(classes.usersRowCell, classes.cost)}>
          {numberToLocaleString(user?.actualCost)}
        </div>
      )}
    </div>
  );
};

export default ReportUserRow;
